import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UtilsService } from '../../../services/utils/utils.service';

@Component({
    selector: 'app-chip-icon',
    templateUrl: './chip-icon.component.html',
    styleUrls: ['./chip-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChipIconComponent implements OnInit {

  @Input() name: string;
  @Input() iconMN: string;
  @Input() customIcon = false;
  @Input() customizeUserIcon = true;
  @Input() template = 'default';

  constructor() {
  }

  ngOnInit() {
  }

  getContent() {
    return UtilsService.getInitialsFromName(this.name);
  }

}
